module.exports = __webpack_public_path__ + "static/media/icon_data_top_main-2.e27aa39a.png";